import ChatDoc from "./ChatDoc";

export default ChatDoc;
